




















































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useOutageNotificationStore } from "@/shared/store/outageNotification";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    GenericLoadingSpinner,
  },
})
export default class OutageNotificationConfiguration extends Vue {
  $validator: Validator;
  isSubmitting = false;
  notificationEnabled = false;
  notificationMessage = "";

  outageNotificationStore = useOutageNotificationStore();
  notifierStore = useNotifierStore();
  rolePermissionsStore = useRolePermissionsStore();

  created () {
    this.outageNotificationStore.loadOutageNotification()
        .then(() => {
          this.notificationEnabled = this.outageNotificationStore.outageNotification &&
              this.outageNotificationStore.outageNotification.enabled || false;
          this.notificationMessage = this.outageNotificationStore.outageNotification &&
              this.outageNotificationStore.outageNotification.message || "";
        });
  }

  onFormEdited () {
    this.$validator.validate();
  }

  onUpdateClicked () {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.$validator.validate()
        .then(result => {
          if (result) {
            return this.outageNotificationStore.setOutageNotification({
              enabled: this.notificationEnabled,
              message: this.notificationMessage
            });
          }
        })
        .then(() => {
          this.notifierStore.setSuccess("Outage notification updated.");
        })
        .finally(() => {
          this.isSubmitting = false;
        });
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityOutageNotifyConfigEdit);
  }
}
